import React, { useEffect, useState } from 'react'
import {
    Text,
    View,
    TextInput,
    TouchableOpacity,
    Image,
    Keyboard,
    BackHandler,
} from 'react-native'
import { FormContentsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import theme from '../../../../theme'
import styles from './InputNumberItemStyles'
import { Feather } from '@expo/vector-icons'
import { schedulesServices } from '../../../../database/schedules.database'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { InputCommentSheet } from './InputCommentItem'
import { placeholderGeneral } from '../../customUtils/Constants'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { ImageWithZoom } from '../../customUtils/Components/ImageWIthZoom'
import { PATH_ASSETS } from '../../../utils/Constants'
import useImageLoader from '../../../hooks/useImageLoader'
import { Loader } from '../../customUtils/Components/Loader'
import { useValidationAlerts } from '../FieldItems/useValidationAlerts'

interface InputNumberItemProps {
    item: FormContentsModel
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
    name_form: string
    keyboardHiddenState: boolean
    onFocus: (id: string) => void
    activeInputId: string
}

export const InputNumberItem = React.memo(
    ({
        item,
        form_id,
        schedule_id,
        store_id,
        checkComplete,
        name_form,
        keyboardHiddenState,
        onFocus,
        activeInputId,
    }: InputNumberItemProps) => {
        const [answer, setAnswer] = useState('')
        const [lastSavedAnswer, setLastSavedAnswer] = useState('')
        const { image, loading, placeholderGeneral } = useImageLoader(
            item.media,
            PATH_ASSETS,
        )
        const [preview, setPreview] = useState(image)

        const { languageFile } = getLanguage()
        const { checkAlerts } = useValidationAlerts()

        useEffect(() => {
            if (item?.old_response) {
                const initialAnswer = item.old_response.question_input || ''
                setAnswer(initialAnswer)
                setLastSavedAnswer(initialAnswer)
            }
        }, [item?.old_response])

        // ❌ DESHABILITADO: onEndEditing ya maneja el guardado cuando el teclado se oculta
        // useEffect(() => {
        //     if (keyboardHiddenState && activeInputId == item._id) {
        //         const timeSinceLastSave = Date.now() - lastSaveTime.current
        //         // Solo ejecutar si pasaron más de 300ms desde la última vez que se guardó
        //         // Esto evita duplicados con onEndEditing
        //         if (answer !== '' && answer !== lastSavedAnswer && timeSinceLastSave > 300) {
        //             handleTextChange(answer, 'efectfocus')
        //         }
        //     }
        // }, [keyboardHiddenState])

        useEffect(() => {
            setPreview(image)
        }, [image])

        const handleTextChange = async (text: string, desde: string = '') => {
            console.log('🚀 ~ handleTextChange ~ text:', text, desde)
            // Evitar guardar si el valor no cambió
            if (text === lastSavedAnswer) {
                console.log('⏭️ Skipping save - value unchanged')
                return
            }
            const action = await checkAlerts(item, text, {
                label: item.title,
                media: item.media || undefined,
            })
            if (action === 'reset') {
                setAnswer('')
                return
            }
            setAnswer(text)
            await create_answer(text)
            setLastSavedAnswer(text)
        }
        const create_answer = async (inputText: string) => {
            let answerScore = '0'
            let canSum = false
            const hasValidTolerance =
                typeof item.tolerance === 'number' && !isNaN(item.tolerance)

            console.log(
                'Tengo tolerancia valida? ==>',
                item.title,
                ' ==> ',
                hasValidTolerance,
            )

            let answerAsNumber = parseFloat(inputText)
            if (!isNaN(answerAsNumber)) {
                if (hasValidTolerance) {
                    canSum = answerAsNumber >= item.tolerance
                } else {
                    canSum = answerAsNumber > 0
                }
            }
            if (item.score != null && canSum === true && inputText != '')
                answerScore = item.score.toString()

            const answer: ModelAnswerFromProps = {
                _id: item._id,
                option_selected_text: [],
                option_selected_id: [],
                question_id: item._id,
                media: '',
                question_text: item.title,
                score: answerScore,
                status: 1,
                date_finish: new Date().toString(),
                date_init: new Date().toString(),
                question_input: inputText,
                field_media: '',
                field_text: '',
                questionScore: item.questionScore,
                type: item.input_type.type,
                ponderar: item.score && item.score > 0, // [7, 8, 14, 18].includes(item.input_type.type),

                question: item.title,
                questionOptionSelected: [],
                questionOptionSelectedText: [],
                questionType: {
                    title: item.input_type.title,
                    type: item.input_type.type,
                    id: item.input_type._id,
                },
                questionPrice: '',
                description: '',
                tag: '',
                questionImage: '',
                questionInput: inputText,
            }
            console.log('InputNumberItem -> create_answer -> answer')
            await updateFormAnswerSchedule({
                newAnswer: answer,
                schedule_id,
                form_id,
                store_id,
                type: 'InputNumberItem',
            })
            await checkComplete(answer)
        }
        const { openBottomSheet, closeBottomSheet } = useBottomSheet()

        const openSheet = () => {
            const isModalClosable = true
            const isModalClosableTouch = true
            const isModalClosableSlice = false
            const keyboardShouldPersistTaps = true
            openBottomSheet(
                <InputCommentSheet
                    answer={answer}
                    handleTextChange={handleTextChange}
                    numeric={true}
                    title={item.title}
                />,
                undefined,
                keyboardShouldPersistTaps,
                isModalClosable,
                isModalClosableSlice,
                isModalClosableTouch,
            )
        }
        const openBigImage = () => {
            if (image) {
                openBottomSheet(
                    <ImageWithZoom uri={image} contentSeen={() => {}} path={''} />,
                    undefined,
                    undefined,
                    true,
                    true,
                    true,
                )
            }
        }
        return (
            <View style={styles.container}>
                <View style={styles.flexDirectionRow}>
                    {item.media && (
                        <TouchableOpacity onPress={() => openBigImage()}>
                            {loading ? (
                                <View
                                    style={[
                                        styles.image,
                                        {
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        },
                                    ]}
                                >
                                    <Loader />
                                </View>
                            ) : (
                                <Image
                                    style={styles.image}
                                    source={{ uri: preview }}
                                    onError={(e) => {
                                        setPreview(placeholderGeneral)
                                    }}
                                />
                            )}
                        </TouchableOpacity>
                    )}

                    <View style={styles.containerData}>
                        {item.title && (
                            <Text style={styles.title}>{item.title ?? ''}</Text>
                        )}
                        {item.description && (
                            <Text style={styles.description}>
                                {item.description ?? ''}
                            </Text>
                        )}
                    </View>

                    {/* {answer.trim() != '' ? (
                    <View style={styles.containerAnswer}>
                        <Text style={styles.answerText}>{answer}</Text>
                        <TouchableOpacity onPress={openSheet}>
                            <Feather name='edit-2' size={16} color={theme.colors.colorPrimary} style={styles.marginLeft} />
                        </TouchableOpacity>
                    </View>
                ) : (
                    <View style={styles.containerMiniButton}>
                        <TouchableOpacity onPress={openSheet} style={styles.miniButton}>
                            <Text style={styles.textMiniButton}>Agregar</Text>
                            <Feather name='edit-2' size={10} color={theme.colors.colorPrimary} style={styles.marginLeft} />
                        </TouchableOpacity>
                    </View>
                )} */}

                    {/*answer.trim() != '' && <Text>{answer}</Text>*/}
                </View>
                <TextInput
                    // autoFocus={true}
                    style={[{ ...styles.input, marginHorizontal: 0, marginTop: 5 }]}
                    onChangeText={(text) => setAnswer(text)}
                    placeholder={languageFile.enter_a_value}
                    value={answer}
                    placeholderTextColor={theme.colors.inputPlaceholder}
                    keyboardType={'numeric'}
                    onEndEditing={(e) =>
                        handleTextChange(e.nativeEvent.text, 'onEndEditing')
                    }
                    onFocus={() => onFocus(item._id)}
                />

                {/* <View style={styles.dividerHorizontalLine}></View> */}
            </View>
        )
    },
)
